export const BAD_REQUEST_STATUS_CODE = 400;
export const UNAUTHORIZED_STATUS_CODE = 401;
export const PAYMENT_REQUIRED_STATUS_CODE = 402;
export const NOT_FOUND_STATUS_CODE = 404;
export const CONFLICT_STATUS_CODE = 409;
export const TIMEOUT_ERROR_STATUS_CODE = 504;
export const SERVER_ERROR_MESSAGE = 'Server error. Please try again later';
